import { colors } from "../utils/const";

export const styles = {
  container: (theme) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "center",
    pt: 4,
    pb: 3,
    color: colors.white,
  }),
};
